
import { Col, FormGroup, Row } from "reactstrap";
import { LabelText } from "../../Utils/Input";
import formSchema from "../../Utils/schema.json";
import { useEffect } from "react";
import { renderField } from "./constants/renderFields";
import { useSelector } from "react-redux";
import { attributeOptions } from "./constants/InitialValues";
import ListConfiguration from "./ListConfiguration";

export default function AttributeDetails({
  setState,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  setIsChecked,
  checked,
  setMandatoryIsChecked,
  mandatoryChecked,
  setMandatoryIsCheckedSelfcare,
  mandatoryCheckedSelfcare,
  setFieldError,
  mandatoryCheckedPersistence,
  setMandatoryIsCheckedPersistence,
  isEdit,
  categoryOptions,
}) {
  useEffect(() => {
    const isListType = values.valueType?.value === "list";

    formSchema.forEach((section) => {
      if (section.title === "Attribute" && section.sections) {
        section.sections.forEach((subSection) => {
          subSection.fields.forEach((field) => {
            if (
              field.name === "minimumValue" ||
              field.name === "maximumValue"
            ) {
              if (
                values?.valueType?.value !== "bool" &&
                values?.type?.value === "customer" &&
                values?.valueType?.value === "integer" &&
                values?.type?.value === "customer" &&
                values?.valueFormat?.value !== "sequence"
              ) {
                field.required = !isListType;
              }
            }
          });
        });
      }
    });

    setState(!isListType);
  }, [values.valueType]);

  useEffect(() => {
    if (
      values.valueType?.value === "list" &&
      values?.type?.value === "customer"
    ) {
      setFieldValue("SelfcareAttribute", []);
    } else {
      setFieldValue("maximumValue", "");
    }
  }, [values.valueType]);

  useEffect(() => {
    const valueType = values?.valueType?.value;

    if (
      valueType === "integer" ||
      valueType === "float64" ||
      valueType === "string"
    ) {
      setFieldValue("maximumValue", 50);
    }
  }, [values?.valueType]);

  const getAttributeDataByName = useSelector(
    (state) => state.GetAttributeByName.getAttribute
  );

  const setAttributesInitalValues = () => {
    setIsChecked(false);
    setMandatoryIsChecked(false);
    setMandatoryIsCheckedSelfcare(false);
    setMandatoryIsCheckedPersistence(false);

    setFieldValue("valueType", "");
    setFieldValue("defaultValue", "");
    setFieldValue("minimumValue", "");
    setFieldValue("maximumValue", "");
    setFieldValue("sequenceValue", "");
    setFieldValue("attributeValue", "");
    setFieldValue("SelfcareAttribute", "");
    setFieldValue("networkField", []);
    setFieldValue("category", []);
  };

  const setAttributesEditValues = (response) => {
    setIsChecked(getAttributeDataByName?.searchable);
    setMandatoryIsChecked(getAttributeDataByName?.mandatory);
    setMandatoryIsCheckedSelfcare(
      getAttributeDataByName?.selfcareVisible
    );
    setMandatoryIsCheckedPersistence(
      getAttributeDataByName?.ratedEventPersistance
    );

    const mappedArray = response?.values?.map((value) => ({
      label: value,
      value: value,
    }));

    const newInitialValues = {
      name: response?.name,

      type: attributeOptions
        .find((attr) => attr.name === "type")
        ?.options?.find((option) => option.value === response?.type),

      valueType: attributeOptions
        .find((attr) => attr.name === "valueType")
        ?.options?.find(
          (option) => option.value === response?.valueType
        ),

      listType:
        response?.listType === "singleSelect"
          ? { label: "Single select", value: "single" }
          : response?.listType === "multiSelect"
            ? { label: "Multi select", value: "multi" }
            : { label: "Open List", value: "open" },

      description: response?.description,
      defaultValue: response?.default,
      minimumValue: response?.minValue,
      maximumValue: response?.maxValue,
      attributeValue: mappedArray,
      SelfcareAttribute: mappedArray,
      sequenceValue: response?.sequenceValue,

      valueFormat:
        response?.sequenceValue !== ""
          ? { value: "sequence", label: "Sequence" }
          : { value: "default", label: "Default" },

      networkField: Array.isArray(response?.networkField)
        ? response.networkField.map((item) => ({
            label: item,
            value: item,
          }))
        : response?.networkField
          ? [
              {
                label: response.networkField,
                value: response.networkField,
              },
            ]
          : [],

      category: Array.isArray(response?.categories)
        ? response.categories.map((item) => ({
            label: item,
            value: item,
          }))
        : [],
    };

    Object.entries(newInitialValues).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
  };

  useEffect(() => {
    if (
      isEdit &&
      values?.type?.value &&
      values?.type?.value === getAttributeDataByName?.type
    ) {
      setAttributesEditValues(getAttributeDataByName);
    } else {
      setAttributesInitalValues();
    }
  }, [values?.type?.value, getAttributeDataByName]);

  useEffect(() => {
    if (values?.type?.value === "inventory") {
      setFieldValue("valueType", {
        value: "string",
        label: "Text",
      });
    }
  }, [values?.type]);

  // Render an individual field using the existing field renderer.
  const renderAttributeField = (field) => {
    const fieldError =
      field.type !== "Selfcare-creatable-select"
        ? touched[field.name] && errors[field.name]
        : errors[field.name];

    const fullWidth =
      field.name === "description" || field.name === "category";

    return (
      <Col
        xxl={fullWidth ? 12 : 4}
        md={fullWidth ? 12 : 6}
        sm={12}
        className="pe-0"
        key={field.name}
      >
        <FormGroup>
          <LabelText
            htmlFor={field.name}
            classLabelName="ms-0 rv-form-label"
            className="text-danger"
            displayText={field.label}
            important={field.required ? "*" : ""}
          />

          <LabelText
            htmlFor={field.name}
            classLabelName={`d-block ms-0 rv-sub-label ${
              fieldError ? "rv-label-danger" : "rv-label-muted"
            }`}
            displayText={
              fieldError
                ? errors[field.name]
                : field.type === "switch"
                  ? field.tooltip
                  : field.placeholder
            }
          />

          {renderField(
            field,
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
            mandatoryChecked,
            mandatoryCheckedPersistence,
            mandatoryCheckedSelfcare,
            isEdit,
            setFieldValue,
            setFieldError,
            setFieldTouched,
            setMandatoryIsChecked,
            setMandatoryIsCheckedPersistence,
            setMandatoryIsCheckedSelfcare,
            setIsChecked,
            checked,
            true,
            categoryOptions
          )}
        </FormGroup>
      </Col>
    );
  };

  return (
    <div className="live-preview">
      {formSchema.map(
        (section, sectionIndex) =>
          section.title === "Attribute" &&
          section.sections &&
          section.sections.map((subSection, subSectionIndex) => {
            const filteredFields = subSection.fields.filter((field) => {
              if (
                field.name === "attributeValue" &&
                values.valueType?.value !== "list"
              ) {
                return false;
              }

              if (
                field.name === "SelfcareAttribute" &&
                values.valueType?.value !== "bool"
              ) {
                return false;
              }

              if (field.name === "searchable") {
                return (
                  values.type?.value === "customer" &&
                  values.valueType?.value === "string"
                );
              }

              if (field.name === "SelfcareAttribute") {
                return (
                  values.type?.value === "customer" &&
                  values.valueType?.value === "bool"
                );
              }

              if (
                field.name === "maximumValue" ||
                field.name === "minimumValue"
              ) {
                if (
                  (values.type?.value === "customer" &&
                    values.valueType?.value === "bool") ||
                  (values.type?.value === "customer" &&
                    values.valueType?.value === "integer" &&
                    values.valueFormat?.value === "sequence")
                ) {
                  return false;
                }
              }

              if (field.name === "defaultValue") {
                if (
                  values.type?.value === "customer" &&
                  values.valueType?.value === "integer" &&
                  values.valueFormat?.value === "sequence"
                ) {
                  return false;
                }
              }

              if (field.name === "valueFormat") {
                return (
                  values.type?.value === "customer" &&
                  values.valueType?.value === "integer"
                );
              }

              if (field.name === "Selfcare") {
                return (
                  values.type?.value === "customer" &&
                  values.valueType?.value === "bool"
                );
              }

              if (field.name === "ratedEventPersistence") {
                return (
                  values.type?.value === "customer" ||
                  values.type?.value === "usage"
                );
              }

              if (field.name === "sequenceValue") {
                return values.valueFormat?.value === "sequence";
              }

              if (field.name === "networkField") {
                return values.type?.value === "usage";
              }

              if (field.name === "category") {
                if (values.type?.value !== "inventory") {
                  return false;
                }

                field.type = "creatable-select";
              }

              return true;
            });

            if (filteredFields.length === 0) {
              return null;
            }

            // First row: Attribute Name, Type and Value Type.
            const firstRowFields = filteredFields.filter((field) =>
              ["name", "type", "valueType"].includes(field.name)
            );

            // All remaining fields are rendered after List Configuration.
            const remainingFields = filteredFields.filter(
              (field) =>
                !["name", "type", "valueType"].includes(field.name)
            );

            return (
              <div
                key={`${sectionIndex}-${subSectionIndex}`}
              >
                <Row className="gy-1 py-2 mt-0 pt-0">
                  {firstRowFields.map((field) =>
                    renderAttributeField(field)
                  )}
                </Row>

                {/* Second row: full-width List Configuration */}
                {values.valueType?.value === "list" && (
                  <Row className="mt-2 mb-2">
                    <Col xs={12}>
                      <ListConfiguration
                        values={values}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        touched={touched}
                      />
                    </Col>
                  </Row>
                )}

                {/* Remaining fields appear below List Configuration */}
                <Row className="gy-1 py-2 mt-0 pt-0">
                  {remainingFields.map((field) =>
                    renderAttributeField(field)
                  )}
                </Row>
              </div>
            );
          })
      )}
    </div>
  );
}
